<script>
  import { Link } from 'svelte-navigator';

  import { user } from '../stores';
  import SelectClass from '../components/SelectClass.svelte';
</script>

<div class="columns">
  <div class="column is-half-desktop is-offset-one-quarter">
    <p class="description my-2 has-text-centered">
      Coordinate classes by sharing the current status with everyone connected
      to the class.
    </p>
    <h1 class="title is-4">Join a Class</h1>
    <SelectClass />
    <hr />
    <div class="mt-3">
      <h1 class="title is-4">Host a Class</h1>
      {#if !$user.loggedIn}
        <Link to="login" class="button is-block is-link is-light is-fullwidth">
          Sign In
        </Link>
      {:else}
        <Link to="teach" class="button is-block is-link is-fullwidth"
          >Host your class</Link
        >
      {/if}
    </div>
  </div>
</div>
